const languages = [
    {code: 'en', language: 'English'},
    {code: 'sv', language: 'Svenska'}
];
export default languages;